<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>Orders Summary</h1>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Filter Summary</h3>
          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse">
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="box-body" style="overflow: unset;">
          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <label for="status">Booking No.</label>

                <input
                  type="text"
                  class="form-control"
                  id="bookingNo"
                  placeholder="Booking No"
                  v-model="params.booking_no"
                  @keyup="onInput"
                />
              </div>
            </div>

            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="status">Merchant Name</label>

                <v-select
                  id="merchant"
                  name="merchant"
                  label="label"
                  v-model="params.merchant"
                  :options="list.merchants"
                  placeholder="Select Merchant"
                ></v-select>
              </div>

            </div>

            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="status">Status Booking</label>

                <select v-model="params.status" class="form-control" id="status">
                  <option value>Select Status</option>
                  <option value="active">Active</option>
                  <option value="checkout">Checkout</option>
                  <option value="expired">Expired</option>
                  <option value="paid">Paid</option>
                </select>
              </div>
            </div>
          </div>

          <hr class="divider" />

          <div class="row">
            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="customerName">Customer Name</label>

                <input
                  type="text"
                  class="form-control"
                  id="customerName"
                  placeholder="Name"
                  v-model="params.member_name"
                />
              </div>

              <div class="form-group">
                <label for="customerEmail">Customer Email</label>

                <input
                  type="text"
                  class="form-control"
                  id="customerEmail"
                  placeholder="Email"
                  v-model="params.member_email"
                />
              </div>
            </div>

            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="departureDate">Departure Date</label>

                <datepicker
                  id="departureDate"
                  format="yyyy-MM-dd"
                  wrapper-class="custom-vdp"
                  input-class="form-control"
                  :clear-button="true"
                  @selected="(date) => { onDateSelected('departureDate', date) }"
                ></datepicker>
              </div>

              <div class="form-group">
                <label>Booking Date</label>

                <div class="row date-row">
                  <div class="col-12 col-sm-6">
                    <datepicker
                      id="bookingDateFrom"
                      format="yyyy-MM-dd"
                      wrapper-class="custom-vdp"
                      input-class="form-control"
                      placeholder="From"
                      :clear-button="true"
                      @selected="(date) => { onDateSelected('bookingDateFrom', date) }"
                    ></datepicker>
                  </div>

                  <div class="col-12 col-sm-6">
                    <datepicker
                      id="bookingDateTo"
                      format="yyyy-MM-dd"
                      wrapper-class="custom-vdp"
                      input-class="form-control"
                      placeholder="To"
                      :clear-button="true"
                      :disabled="disabledDates"
                      @selected="(date) => { onDateSelected('bookingDateTo', date) }"
                    ></datepicker>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="productName">Product Name</label>

                <input
                  type="text"
                  class="form-control"
                  id="productName"
                  v-model="params.package_name"
                />
              </div>

              <div class="form-group">
                <label for="source">Source</label>

                <select class="form-control" id="source" title="Pilih" v-model="params.source">
                  <option value>Select Source</option>
                  <option value="misteraladin">Mister Aladin</option>
                </select>
              </div>
            </div>

            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="promoCode">Promo Code</label>

                <input type="text" class="form-control" id="promoCode" v-model="params.promo_code" />
              </div>

              <div class="form-group">
                <label for="paymentMethod">Payment Method</label>

                <v-select
                  id="methods"
                  name="methods"
                  label="label"
                  v-model="params.payment_method"
                  :options="payment_methods"
                  placeholder="Select Payment Method"
                ></v-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="customerName">Redeem At From</label>
                <datepicker
                  id="redemAtFrom"
                  format="yyyy-MM-dd"
                  wrapper-class="custom-vdp"
                  placeholder="From"
                  input-class="form-control"
                  :clear-button="true"
                  @selected="(date) => { onDateSelected('redeem_at_from', date) }"
                />
              </div>
            </div>

            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="customerName">Redeem At To</label>
                <datepicker
                  id="redeemAtTo"
                  format="yyyy-MM-dd"
                  wrapper-class="custom-vdp"
                  placeholder="To"
                  input-class="form-control"
                  :clear-button="true"
                  @selected="(date) => { onDateSelected('redeem_at_to', date) }"
                />
              </div>
            </div>

            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="customerName">Check In At From</label>
                <datepicker
                  id="checkinAtFrom"
                  format="yyyy-MM-dd"
                  wrapper-class="custom-vdp"
                  placeholder="From"
                  input-class="form-control"
                  :clear-button="true"
                  @selected="(date) => { onDateSelected('checkin_at_from', date) }"
                />
              </div>
            </div>

            <div class="col-12 col-sm-3">
              <div class="form-group">
                <label for="customerName">Check In At To</label>
                <datepicker
                  id="checkinAtTo"
                  format="yyyy-MM-dd"
                  wrapper-class="custom-vdp"
                  placeholder="To"
                  input-class="form-control"
                  :clear-button="true"
                  @selected="(date) => { onDateSelected('checkin_at_to', date) }"
                />
              </div>
            </div>
          </div>


          <hr class="divider" />
          <div class="row">
            <div class="col-12 col-sm-12">
              <div class="form-group">
                <label>Issued Date</label>
                <div class="row date-row">
                  <div class="col-12 col-sm-6">
                    <datepicker
                      id="paidFrom"
                      format="yyyy-MM-dd"
                      wrapper-class="custom-vdp"
                      input-class="form-control"
                      placeholder="From"
                      @selected="(date) => { onPaidSelected('paidFrom', date) }"
                    ></datepicker>
                  </div>

                  <div class="col-12 col-sm-6">
                    <datepicker
                      id="paidTo"
                      format="yyyy-MM-dd"
                      wrapper-class="custom-vdp"
                      input-class="form-control"
                      placeholder="To"
                      @selected="(date) => { onPaidSelected('paidTo', date) }"
                    ></datepicker>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box-footer">
          <button type="button"
            class="btn btn-success"
            @click="onExportCsv('normal')">
            Export CSV
          </button>
          <button type="button"
            class="btn btn-success"
            @click="onExportCsv('finance')">
            Export CSV for Finance
          </button>

          <button type="button" class="btn btn-primary pull-right" @click="fetch">Search</button>
        </div>
      </div>

      <div class="box box-success">
        <div class="box-body no-padding">
          <div class="table-responsive">
            <table id="table" class="table table-bordered table-striped">
              <thead>
                <tr class="nowrap">
                  <th class="text-center" style="min-width: 15rem">Booking Date</th>
                  <th class="text-center" style="min-width: 12rem">Booking No</th>
                  <th class="text-center" style="min-width: 10rem">Media</th>
                  <th>Product Name</th>
                  <th style="min-width: 10rem">Departure Date</th>
                  <th style="min-width: 15rem">Merchant Name</th>
                  <th style="min-width: 15rem">Customer Name</th>
                  <th style="min-width: 15rem">Customer Email</th>
                  <th style="min-width: 12rem">Customer Phone</th>
                  <th style="min-width: 12rem">Payment Method</th>
                  <th class="text-center" style="min-width: 10rem">Card Type</th>
                  <th class="text-center" style="min-width: 10rem">Bank Name</th>
                  <th class="text-center" style="min-width: 10rem">Tenor</th>
                  <th class="text-center" style="min-width: 10rem">MDR</th>
                  <!-- <th style="min-width: 10rem">Charging Fee Type</th>
                  <th style="min-width: 10rem">Charging Fee Value</th> -->
                  <th style="min-width: 10rem">Promo Code</th>
                  <th style="min-width: 10rem">Promo Amount</th>
                  <th class="text-center" style="min-width: 10rem">Installment/Charging Fee</th>
                  <th style="min-width: 10rem">Total Publish Rate</th>
                  <th style="min-width: 10rem">Payment Amount</th>
                  <th style="min-width: 10rem">Issued date</th>
                  <th style="min-width: 10rem">Latitude</th>
                  <th style="min-width: 10rem">Longitude</th>
                  <th class="text-center" style="min-width: 10rem">Status</th>
                  <th class="text-center" style="min-width: 10rem">Action</th>
                </tr>
              </thead>

              <tbody>
                <tr v-if="isLoading" key="loading">
                  <td colspan="18" class="text-center">
                    <circle2></circle2>
                  </td>
                </tr>

                <tr v-else-if="orders.length < 1" key="empty">
                  <td class="text-center" colspan="18">Data Not Found</td>
                </tr>

                <tr v-else v-for="(order, index) in orders" :key="index">
                  <td class="text-center">{{ parseTime(order.created_at) }}</td>
                  <td class="text-center">
                    <span
                      class="badge badge-primary pointer"
                      @click="onBookingNoClick(order.hash)"
                    >{{ order.booking_no }}</span>
                  </td>

                  <td class="text-center">{{ capitalizeFirstLetter(order.media) }}</td>

                  <td>
                    <span class="truncate">{{ order.package_name }}</span>
                  </td>

                  <td>{{ order.visit_date }}</td>

                  <td>
                    <span class="truncate" v-if="order.items[0].product.merchant.name">
                      {{ order.items[0].product.merchant.name }}
                    </span>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <td>
                    <span class="truncate" v-if="order.member_name">{{ order.member_name }}</span>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <td>
                    <span v-if="order.member_email">{{ order.member_email }}</span>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <td>
                    <span v-if="order.member_phone">{{ order.member_phone }}</span>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <td class="text-center">
                    <span v-if="order.payment.payment_method">{{ order.payment.payment_method }}</span>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <td class="text-center">
                    <span v-if="order.payment.card_type">{{ capitalizeFirstLetter(order.payment.card_type) }}</span>
                    <span v-else>-</span>
                  </td>

                  <td class="text-center">
                    <span v-if="order.payment.bank">{{ order.payment.bank }}</span>
                    <span v-else>-</span>
                  </td>

                  <td class="text-center">
                    <span v-if="order.payment.installment_term">{{ order.payment.installment_term }}</span>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <td class="text-center">
                    <span v-if="order.payment.installment_mdr">{{ order.payment.installment_mdr }}%</span>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <!-- <td class="text-center">
                    <span v-if="order.payment.charging_fee_type"> {{ order.payment.charging_fee_type }}</span>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <td class="text-center">
                    <span v-if="order.payment.service_fee_value">
                      {{ order.payment.service_fee_value && order.payment.charging_fee_type == 'percentage' ? `${order.payment.service_fee_value} %` : `IDR ${numberFormat(order.payment.service_fee_value)}` }}
                    </span>
                    <span v-else class="text-center">-</span>
                  </td> -->

                  <td class="text-center">
                    <kbd v-if="order.promo_code.code">{{ order.promo_code.code }}</kbd>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <td class="text-center">
                    <template
                      v-if="order.total_discount_promo_code != 0"
                    >IDR {{ numberFormat(order.total_discount_promo_code) }}</template>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <td class="text-center">
                    <span v-if="order.payment.charging_fee_price && order.payment.charging_fee_price > 0 && order.payment.installment_fee == 0">
                      IDR {{ numberFormat(order.payment.charging_fee_price) }}
                    </span>
                    <span v-if="order.payment.installment_fee && order.payment.installment_fee > 0">
                      IDR {{ numberFormat(order.payment.installment_fee) }}
                    </span>
                    <span v-if="order.payment.charging_fee_price == 0 && order.payment.installment_fee == 0">
                      <span class="text-center">-</span>
                    </span>
                  </td>

                  <td>IDR {{ numberFormat(order.total_publish_rate) }}</td>

                  <td>IDR {{ numberFormat(order.payment.amount) }}</td>

                  <td>{{ order.paid_at }}</td>

                  <td>{{ order.latitude }}</td>

                   <td>{{ order.longitude }}</td>

                  <td class="text-center">
                    <span
                      class="label label-status"
                      :class="order.status === 'paid' ? 'label-success':'label-default'"
                    >{{ capitalizeFirstLetter(order.status) }}</span>
                  </td>

                  <td class="text-center">
                    <button
                      class="btn btn-primary btn-xs"
                      @click="onBookingNoClick(order.hash)"
                    >View Detail</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="box-footer">
          <Pagination :pagination="pagination" @goto-page="changePage" />
        </div>
      </div>
      <transition name="modal">
        <div class="modal-mask" @click.self="modalError = !modalError" v-if="modalError">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" @click.prevent="modalError = !modalError">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title" style="text-align: center">Please input Booking Date before export the data</h4>
                </div>
                <div class="modal-body" style="text-align: center">
                  <div class="row">
                    <div class="col-12 col-sm-12">
                      <div class="form-group">
                        <label>Input Booking Date From and To within a maximum range of 6 months</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="modal">
        <div class="modal-mask" @click.self="modalVisible = !modalVisible" v-if="modalVisible">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" @click.prevent="modalVisible = !modalVisible">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">Participant Detail - {{ orderDetail.booking_no }}</h4>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-12 col-sm-12">
                      <div class="form-group">
                        <label>Product Name : {{ orderDetail.package_name }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table id="table" class="table table-bordered table-striped">
                      <thead>
                        <tr class="nowrap">
                          <th>Price Name</th>
                          <th>Unique Code</th>
                          <th>Wristband Code</th>
                          <th>Redeem At</th>
                          <th>Check In At</th>
                          <th>Nett Rate</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="item in orderDetail.items">
                          <template v-for="ticket in item.tickets">
                            <tr :key="ticket.id">
                              <td>{{ item.price_name }}</td>
                              <td>{{ ticket.unique_code }}</td>
                              <td>{{ ticket.wristband_code }}</td>
                              <td>{{ parseTime(ticket.redeem_at) }}</td>
                              <td>{{ parseTime(ticket.checkin_at) }}</td>
                              <td>IDR {{ item.nett_rate }}</td>
                            </tr>
                          </template>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { Circle2 } from 'vue-loading-spinner';
import Common from '@/mixins/Common';
import Pagination from '@/components/modules/common/Pagination';
import API_BASEURL, { X_API_KEY } from '@/config';
import Modal from '@/components/modules/common/Modal';

export default {
  name: 'OrderSummary',

  mixins: [Common],

  data() {
    return {
      orders: [],
      pagination: {},
      isLoading: true,
      type: 'json',
      modalVisible: false,
      modalError: false,
      orderDetail: null,
      payment_methods: [],
      list: {
        merchants: [],
      },

      params: {
        booking_no: null,
        merchant: null,
        member_name: null,
        member_email: null,
        status: '',
        date_from: null,
        date_to: null,
        departure_date: null,
        source: '',
        package_name: null,
        promo_code: null,
        payment_method: null,
        paid_from: null,
        paid_to: null,
        redeem_at_from: null,
        redeem_at_to: null,
        checkin_at_from: null,
        checkin_at_to: null,
        export_csv: 0,
        page: 1,
        perpage: 20,
      },
    };
  },

  components: {
    Pagination,
    Datepicker,
    Circle2,
    Modal,
  },
  computed: {
    disabledDates() {
      const today = moment().toDate();
      if (this.params.date_from) {
        return {
          from: moment(this.params.date_from).add(6, 'month').toDate(),
        };
      }
      return {
        // to: moment().toDate(),
        from: today,

      };
    },
  },
  methods: {
    async fetch() {
      this.isLoading = true;
      this.setListEmpty();

      const queryParams = await this.populateQueryParams();

      this.axios.get('/orders', {
          params: queryParams,
          responseType: this.type,
        })
        .then((response) => {
          this.params.export_csv = 0;

          if (this.type !== 'json') {
            const blob = new Blob([response.data], {
              type: 'text/csv',
            });
            const url = window.URL.createObjectURL(blob);

            window.open(url);
            this.type = 'json';
            return;
          }

          const { data, meta } = response.data;

          if (!data && (meta.pagination.current_page > meta.pagination.total_pages)) {
            this.setListEmpty();
            this.isLoading = false;
            return;
          }

          this.orders = data;
          this.pagination = meta.pagination;
          this.isLoading = false;
        })
        .catch(() => {
          this.params.export_csv = 0;
          this.isLoading = false;

          this.$swal({
            title: 'Fetch Failed',
            text: 'Failed to fetch BIN data',
            type: 'warning',
            timer: 3000,
          });
        });
    },

    fetchItem(type) {
      return new Promise((resolve) => {
        this.axios.get(`/${type}`, { params: { perpage: 5000 } })
          .then((response) => {
            const { data } = response.data;
            const results = data.map(item => ({ label: item.name, value: item.id }));
            this.list[type] = results;
            resolve(data);
          })
          .catch((error) => {
            console.log(`Fetch ${type} error`, error);

            if (error.response) {
              this.error = error.response.data.errors;
            }

            if (error) {
              this.$swal({
                title: 'Failed',
                text: `Failed to fetch available ${type}`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#666',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Try again',
              }).then((result) => {
                if (result.value) {
                  this.fetchItem(type);
                }
              });
            }
          });
      });
    },

    setListEmpty() {
      this.orders = [];
      this.pagination = {};
    },

    getPaymentMethods() {
      const config = {
        baseURL: API_BASEURL,
        params: {
          page: 1,
          perpage: 100,
        },
      };

      this.axios.get('/payments/v2/payment-method', config)
        .then((response) => {
          const { data } = response.data;
          data.forEach((item) => {
            if (item.active) {
              this.payment_methods.push({
                label: item.name,
                value: item.slug,
              });
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.$swal({
            title: 'Failed',
            text: 'Failed to fetch available payment methods',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#666',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Try again',
          }).then((result) => {
            if (result.value) {
              // this.getPaymentMethods();
            }
          });
        });
    },

     populateQueryParams() {
      return new Promise((resolve) => {
        const params = {
          booking_no: this.params.booking_no,
          merchant: this.params.merchant ? this.params.merchant.value : null,
          member_name: this.params.member_name,
          member_email: this.params.member_email,
          status: this.params.status,
          date_from: this.params.date_from,
          date_to: this.params.date_to,
          visit_date: this.params.departure_date,
          source: this.params.source,
          package_name: this.params.package_name,
          promo_code: this.params.promo_code,
          payment_method: this.params.payment_method,
          export_csv: this.params.export_csv,
          paid_from: this.params.paid_from,
          redeem_at_from: this.params.redeem_at_from,
          redeem_at_to: this.params.redeem_at_to,
          checkin_at_from: this.params.checkin_at_from,
          checkin_at_to: this.params.checkin_at_to,
          paid_to: this.params.paid_to,
          page: this.params.page,
          perpage: this.params.perpage,
        };

        if (this.params.payment_method) {
          params.payment_method = this.params.payment_method.value;
        }

        resolve(params);
      });
     },

    changePage(page) {
      this.params.page = page;
      this.fetch();
    },

    async onExportCsv(type) {
      let params = '';
      this.params.export_csv = 1;

      const totalRow = this.pagination.total;
      const queryParams = await this.populateQueryParams();

      Object.keys(queryParams).forEach((key) => {
        if (key === 'perpage') {
          params += `${key}=${totalRow || ''}&`;
        } else {
          params += `${key}=${queryParams[key] || ''}&`;
        }
      });

      params = params.slice(0, -1);
      // paid_from=2022-03-02&paid_to=2022-03-0
      if (this.params.date_from && this.params.date_to) {
        let url = '';
        if (type === 'finance') {
          url = `${API_BASEURL}/orders/finance?${params}`;
        } else {
          url = `${API_BASEURL}/orders?${params}`;
        }
        window.location = url;
      } else {
        this.modalError = true;
      }
    },

    onInput: debounce(function debouncedInput() {
      this.fetch();
    }, 500),

    onDateSelected(type, date) {
      date = this.parseTime(date, 'YYYY-MM-DD');

      if (type === 'departureDate') {
        this.params.departure_date = date;
      }

      if (type === 'bookingDateFrom') {
        this.params.date_from = date;
      }

      if (type === 'bookingDateTo') {
        this.params.date_to = date;
      }

      if (type === 'redeem_at_from') {
        this.params.redeem_at_from = date;
      }

      if (type === 'redeem_at_to') {
        this.params.redeem_at_to = date;
      }

      if (type === 'checkin_at_from') {
        this.params.checkin_at_from = date;
      }

      if (type === 'checkin_at_to') {
        this.params.checkin_at_to = date;
      }
    },

    onPaidSelected(type, date) {
      date = this.parseTime(date, 'YYYY-MM-DD');

      if (type === 'paidFrom') {
        this.params.paid_from = date;
      }

      if (type === 'paidTo') {
        this.params.paid_to = date;
      }
    },

    onBookingNoClick(hash) {
      const config = {
        headers: {
          'X-Api-Key': `${X_API_KEY}`,
        },
      };

      if (!hash) {
        this.modalVisible = false;
        return;
      }

      this.modalVisible = true;

      this.axios.get(`orders/${hash}`, config)
        .then((response) => {
          const { data } = response.data;
          this.orderDetail = data;
        })
        .catch((error) => {
          console.log('error', error);
        });
    },
  },

  async created() {
    this.getPaymentMethods();
    await this.fetchItem('merchants');
    await this.fetch();
  },
};
</script>

<style lang="scss" scoped>
@import '../style';
</style>



// WEBPACK FOOTER //
// src/components/modules/orders/summary/Index.vue